module.exports = __webpack_public_path__ + "static/jeanine-001-8daa06d3d7a2a6a436ad87a6fcda2248.jpg";